import "src/components/Layout/Layout.module.scss?css";
export default {"layout":"layout__Pk73vG","mainLayout":"mainLayout__cxWecu"};